import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import jaJP from 'antd/lib/locale/ja_JP';
import { useTranslation } from 'react-i18next';

import SystemManage from "./pages/SystemManage/index";
import WebFront from "./pages/Web/index";
import Login from "./pages/Login";

import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import 'moment/locale/zh-cn';
import 'moment/locale/ja';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ja';

dayjs.extend(weekday)
dayjs.extend(localeData)

function App() {
  const { i18n } = useTranslation();

  const ThemeConfig = {
    token: {
      colorPrimary: "#2e8bc0",
      colorLink: "rgb(41,171,226)",
      // colorError: "#FF4D4F",
      // colorSuccess: "#52C41A",
      colorTextBase: "#0c2d48",
      // colorWarning: "#FAAD14",
      borderRadius: 4,
      fontFamily: 'Source Han Sans SC, Noto Sans CJK SC, sans-serif'
      // colorPrimaryHover: "#4978FF"
    },
  };

  return (
    <ConfigProvider
      theme={ThemeConfig}
      locale={
        window.location?.pathname?.startsWith("/system_manage") ? zhCN : (
          i18n.language === 'ja' ? jaJP :
            i18n.language === 'zh' ? zhCN : enUS
        )
      }>
      <BrowserRouter>
        <Routes>
          <Route path="system_manage/*" element={<SystemManage />} />
          <Route path="login" element={<Login />} />
          <Route path="*" element={<WebFront />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  )
}

export default App;
